import { Directive, inject } from '@angular/core';
import { DropdownComponent } from './dropdown.component';

@Directive({
  selector: '[tvdDropdownNavigator]',
  host: {
    '(keydown.arrowdown)':
      '$event.preventDefault(); $event.stopPropagation(); next()',
    '(keydown.tab)':
      '$event.preventDefault(); $event.stopPropagation(); next()',
    '(keydown.arrowup)':
      '$event.preventDefault(); $event.stopPropagation(); previous()',
    '(keydown.shift.tab)':
      '$event.preventDefault(); $event.stopPropagation(); previous()',
  },
})
export class DropdownNavigatorDirective {
  readonly #items = inject(DropdownComponent).items;

  next() {
    this.#goToItem(1);
  }

  previous() {
    this.#goToItem(-1);
  }

  #goToItem(index: number) {
    const idx = this.#items().findIndex((item) => item.highlighted());
    const nextIdx = (idx + index) % this.#items().length;

    const item = this.#items().at(nextIdx);
    if (!item) {
      return;
    }
    if (item.disabled()) {
      const nearestEnabled = this.#items()
        .slice(nextIdx)
        .find((item) => !item.disabled());
      if (!nearestEnabled) {
        return;
      }
      this.#goToItem(index + index);
      return;
    }
    for (const item of this.#items()) {
      item.highlighted.set(false);
    }
    item.highlighted.set(true);
  }
}
